import React from "react"
import {StyledSelect} from "./component"
import {SelectProps} from "../.."
import {StyledOutlinedInput} from "../../component"

export const StandardCountrySelect = ({
    value,
    onChange,
    onOpen,
    onKeyPress,
    MenuProps,
    input,
    IconComponent,
    children,
}: SelectProps) => {
    return (
        <StyledSelect
            value={value}
            onChange={onChange}
            onOpen={onOpen}
            onKeyPress={onKeyPress}
            MenuProps={MenuProps}
            IconComponent={IconComponent}
            input={
                <StyledOutlinedInput
                    data-testid="country-selector-select-input"
                    name="country-selector-select"
                    id="country-selector-select"
                />
            }
        >
            {children}
        </StyledSelect>
    )
}

export default StandardCountrySelect
